import styles from './CrumbSeparator.module.scss';

const CrumbSeparator = () => (
  <span className={styles['search-breadcrumbs-separator']}>›</span>
);

export default CrumbSeparator;
